const REQUIRED_HEADERS = ["Ürün Adı", "Marka", "Ana Kategori Adı", "Ürün Detayı", "Barkod", "Tedarikçi Ürün Kodu"];
const labels = { name: "Ürün adı", brand: "Marka", subcategory: "Kategori", description: "Açıklama" };

const parseLine = (line) => {
  const cells = []; let cell = ""; let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const character = line[index];
    if (character === '"' && quoted && line[index + 1] === '"') { cell += '"'; index += 1; }
    else if (character === '"') quoted = !quoted;
    else if (character === ";" && !quoted) { cells.push(cell); cell = ""; }
    else cell += character;
  }
  cells.push(cell);
  return cells;
};

const splitRows = (text) => {
  const rows = []; let row = ""; let quoted = false;
  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    if (character === '"' && quoted && text[index + 1] === '"') { row += '""'; index += 1; }
    else if (character === '"') { quoted = !quoted; row += character; }
    else if ((character === "\n" || character === "\r") && !quoted) { if (row.trim()) rows.push(row); row = ""; if (character === "\r" && text[index + 1] === "\n") index += 1; }
    else row += character;
  }
  if (row.trim()) rows.push(row);
  return rows;
};

const htmlToText = (value) => value.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&").replace(/\s+/g, " ").trim();

export const parseProductCsv = (text) => {
  const rows = splitRows(text.replace(/^\uFEFF/, ""));
  if (!rows.length) return { products: [], invalidRows: [{ row: 1, reason: "Dosya boş" }] };
  const headers = parseLine(rows[0]).map((header) => header.trim());
  const missingHeaders = REQUIRED_HEADERS.filter((header) => !headers.includes(header));
  if (missingHeaders.length) return { products: [], invalidRows: [{ row: 1, reason: `Eksik sütunlar: ${missingHeaders.join(", ")}` }] };
  const indexOf = (header) => headers.indexOf(header);
  const products = []; const invalidRows = [];
  rows.slice(1).forEach((line, index) => {
    const cells = parseLine(line);
    const product = {
      name: (cells[indexOf("Ürün Adı")] || "").trim(), brand: (cells[indexOf("Marka")] || "").trim(), subcategory: (cells[indexOf("Ana Kategori Adı")] || "").trim(), description: htmlToText((cells[indexOf("Ürün Detayı")] || "").trim()), barcode: (cells[indexOf("Barkod")] || "").trim(), supplier_code: (cells[indexOf("Tedarikçi Ürün Kodu")] || "").trim(),
    };
    const emptyKey = Object.keys(labels).find((key) => !product[key]);
    if (emptyKey) invalidRows.push({ row: index + 2, reason: `${labels[emptyKey]} eksik` });
    else products.push(product);
  });
  return { products, invalidRows };
};
